import { type FC, type ReactNode } from "react";
import { Box, Button, Typography } from "@mui/material";

import "../top/Top.css";
import { LinearText } from "../../utils";
import { ContentCopy } from "@mui/icons-material";

interface TopProps {
    title: string;
    subTitle: string;
    description?: string;
    children?: ReactNode;
    contractAddress?: string;
}

const Top: FC<TopProps> = ({ title, subTitle, description, children, contractAddress }) => {
 

    const onCopy = () => {
        navigator.clipboard.writeText(localStorage.getItem("tokenContractAddress") || '');
        console.log('Copied:', localStorage.getItem("tokenContractAddress"))
    };
    return (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mx={2}>
            <Typography sx={{ fontSize: { xs: '24px', sm: '38px' } }} fontWeight={600}>
                {title}
                <LinearText>{subTitle}</LinearText>
                {contractAddress &&
                    <Box display={"flex"} sx={{ justifyContent: 'center', alignItems: "center" }} >
                        <Box
                            sx={{
                                fontSize: { xs: '12px', sm: '19px' },
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            {`${contractAddress.slice(0, 8)}...${contractAddress.slice(-5)}`}
                        </Box>


                        <ContentCopy onClick={onCopy} sx={{ cursor: "pointer" }} className="icon-copy" />

                    </Box>
                }
            </Typography>
            <Typography textAlign={'center'} sx={{ fontSize: { xs: '18px', md: '28px' } }}>
                {description}
            </Typography>
        </Box >
    );
};

export default Top;
